export const ADDRESS_LOOKUP_REQUEST = 'ADDRESS_LOOKUP_REQUEST';
export const ADDRESS_LOOKUP_REQUEST_SUCCESS = 'ADDRESS_LOOKUP_REQUEST_SUCCESS';
export const ADDRESS_LOOKUP_REQUEST_FAILURE = 'ADDRESS_LOOKUP_REQUEST_FAILURE';

export const ADD_DATA_BY_STREET_REQUEST = 'ADD_DATA_BY_STREET_REQUEST';
export const ADD_DATA_BY_STREET_REQUEST_SUCCESS = 'ADD_DATA_BY_STREET_REQUEST_SUCCESS';
export const ADD_DATA_BY_STREET_REQUEST_FAILURE = 'ADD_DATA_BY_STREET_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/address_lookup.constants.js